<template>
  <div :class="['container', { 'container-dark': theme_dark }]" >
    <input type="file" id="___file_upload" ref="referenceUpload" accept="image/*" @change="upload"/>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">相册</div>
      <div class="nav-right">
        <span class="nav-lable" @click="setUp()">设置</span>
        <img src="../../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>

    <div class="content ub ub-ver" @click="gift_hidden()">
      <div class="tip ub ub-ver">
        <span>请上传真人照片，审核成功才会被展示，点击照片预览，右上角管理按钮可管理照片，可以删除、置顶、设为背景等。</span>
        <span>审核通过的照片会显示在个人主页的相册中，其他用户想要看你的相册需要为你赠送礼物，你会得到积分，会增加你的魅力值。</span>
        <span>右上角设置，可选择想要的礼物对方需赠送对应的礼物解锁相册，默认赠送任意礼物即可解锁相册。</span>
      </div>

      <div class="photo ub ub-pc flexWrap ub-ps">
        <div class="upload ub ub-pc ub-ac" @click="upload_img()">
          <img src="../../assets/img/上传截图.png" />
        </div>
        <li v-for="(i, index) in ayy_pic" :key="index" :style="{ 'background-image': 'url(' + i.url + ')' }" class="face-img ub ub-ae" @click="show_full(i)">
          <div class="img-state ub ub-pc ub-ac" v-if="i.check_state == 0">
            <span class="state1">待审核</span>
          </div>
          <div class="img-state ub ub-pc ub-ac" v-if="i.check_state == 2">
            <span class="state3">不通过</span>
          </div>
        </li>
      </div>

      <div class="btn-clock ub ub-pc ub-ac" v-if="arr_serve.length > 0">
        <div class="ub ub-ac ub-pc btn" @click="btn_more()"><span>加载更多</span></div>
      </div>

    </div>

    <full_pic ref="myFullPic" @deleteImage="handleDeleteImage" @topImage="topImage" @bgImage="bgImage"></full_pic>
    <album_gift v-if="gifts_show" :uid="uid" @gift_hidden="gift_hidden"></album_gift>
  </div>
</template>

<script>
import Exif from "exif-js";
import { mapMutations, mapActions } from "vuex";
import * as tool from "../../api/common";
import full_pic from "../../components/Preview_Picture.vue";
import album_gift from "../../components/Album_Gift.vue";
export default {
  components: {
    full_pic: full_pic,
    album_gift: album_gift,
    
  },
  data() {
    return {
      uid: "",
      to_uid: "",
      ayy_pic: [],
      arr_serve:[],
      size: 9,
      theme_dark: false,
      gifts_show: false
    };
  },

  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page()
  },

  methods: {
    ...mapMutations(["get", "post", "post2"]), //引入方法
    ...mapActions(["act_reload_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page(){
      var uid = this.$store.state.uid;
      this.uid = uid;
      var self = this;
      this.get({
        url: "/App/Get_Album_Self/?uid=" + uid,
        success: function (data) {
          for(var i in data) {
            data[i].url = self.$store.state.url + "/photo/" + data[i].url;
          }
          self.arr_serve = data;
          self.btn_more();
        },
      });

    },

    //设置
    setUp() {
      this.gifts_show = true;
    },

    //关闭设置
    gift_hidden() {
      this.gifts_show = false;
    },
    
    //加载更多
    btn_more() {
          var self = this;

          var arr_count = self.arr_serve.length;
          var len_count = self.size;
          if( arr_count < self.size)
          {
            len_count = arr_count;
          }
          
          //首页减少一张照片
          if(self.ayy_pic.length == 0 && self.arr_serve.length >= self.size){
            len_count--;
          }

          for(var i=0; i<len_count; i++)
          {
              var item = self.arr_serve.shift();
              self.ayy_pic.push(item);
          }
    },
    
    //保存数据
    save_album(item) {
      var uid = this.$store.state.uid;
        var data_send = {
          uid: uid,
          url: item
        };

        var strsend = JSON.stringify(data_send);
        var other = this;
          this.post({
            url: "/App/Album_AddPhoto",
            data: {uid: uid, data: strsend},
            success: function (serve_data) {
              // console.log(JSON.stringify(serve_data));
              var item = JSON.parse(serve_data.item);
              item.url = other.$store.state.url + "/photo/" + item.url;

              if (serve_data.state == "1") {
                other.ayy_pic.unshift(item);
                other.$toast.top("上传成功");

                var bll_id = item.id || "";
                var msg = {
                  "txt": "相册审核",
                  "desc": "你上传的照片已提交审核专员进行审核，请耐心等待一下",
                  "id": bll_id
                }
                tool.send_check_msg(other,"check_album",msg,true);
              }
            },
          });
    },
    
    show_full(item) {
      //console.log(JSON.stringify(item));
      this.$refs.myFullPic.show(item);
    },

    handleDeleteImage(id) {
      var self = this
      self.get({
        url: "/App/Delete_AlbumItem/" + id,
        success: function (data) {
         if(data.state == "1") {
          self.$toast.top("删除成功");
          //移除该元素（照片）
          var delete_index = 0;
          for(var i=0; i<self.ayy_pic.length;i++){
            if(self.ayy_pic[i].id == id){
               delete_index = i;
            }
          }
          self.ayy_pic.splice(delete_index, 1);
         }
        },
      });
    },

    topImage(item) {
      var self = this;
      self.get({
        url: "/App/UpTop_Album/" + item.id,
        success: function (data) {
         if(data.state == "1") {
          self.$toast.top("置顶成功");
          //移除该元素（照片）,并且给加到第一个
          var index = self.ayy_pic.indexOf(item);
          var opt_item = {};
          if (index > -1) {
            opt_item = self.ayy_pic.splice(index, 1);
          }
          //console.log(JSON.stringify(opt_item[0]));
          self.ayy_pic.unshift(opt_item[0]);
         }
        },
      });
    },

    bgImage(item) {
      var self = this;
      var uid = this.$store.state.uid;

      if (item.check_state == 1) {
        var send_data = { "pic_back": item.url };
        var data = {
            url: "/App/User_ModifyBaseInfo",
            data: {
              uid: uid,
              data: JSON.stringify(send_data),
            },
            success: function (data_serve) {
              if (data_serve.state == "1") {
                self.act_reload_userinfo({
                  uid: uid,
                  success: function (info) {
                    self.$toast.center('设为背景成功');
                  },
                });
              }
            },
          };
          self.post(data);
      } else {
        this.$toast.center("未通过的照片不能设为背景~");
      }
    },


    /*  上传照片 ---start-----  */
    upload_img() {
      //触发input的change事件
      var ie =
        navigator.appName == "Microsoft Internet Explorer" ? true : false;
      if (ie) {
        document.getElementById("___file_upload").click();
      } else {
        var a = document.createEvent("MouseEvents"); //FF的处理
        a.initEvent("click", true, true);
        document.getElementById("___file_upload").dispatchEvent(a);
      }
    },
    upload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.picValue = files[0];

      var arrExt = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];
      var file_name = this.picValue.name;
      var fileExt = file_name.substr(file_name.lastIndexOf(".")).toLowerCase();

      if (arrExt.indexOf(fileExt) <= -1) {
        //上传文件格式不正确
        this.$toast.center("不支持您所选的图片格式~");
        return false;
      }

      //toast 启动动画
      this.$loading("上传中...");

      this.imgPreview(this.picValue);
    },
    postImg() {
      var self = this;

      //这里写接口
      var base64 = this.headerImage;
      let param = new FormData(); // 创建form对象
      param.append("imgFile", base64); //对应后台接收图片名

      //判断base64 是否成功, 长度>10
      if (base64.length < 10) {
        //消掉动画
        self.$loading.close();
        self.$toast.center("图片处理失败,请重新选择");
        return false;
      }

      self.post2({
        url: "/Common/UpLoadAlbum_Base64",
        data: param,
        success: function (serve_data) {
          //消掉动画
          self.$loading.close();
          self.save_album(serve_data);
        },

        error: function (err) {
          //消掉动画
          self.$loading.close();
          self.$toast.center("上传失败,请重新再来");
        },
      });
    },

    imgPreview(file) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function () {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于1M,是就直接上传，反之压缩图片
          var pic_size = ((this.result.length * 1.0) / (1024 * 1024)).toFixed(2);
          //console.log(pic_size);
          if (this.result.length <= 1 * 1024 * 1024) {
            self.headerImage = this.result;
            //console.log("不用压缩直接上传...");

            self.postImg();
          } else {
            //console.log("开始压缩...");
            img.onload = function () {
              let data = tool.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },
    /*  上传照片 ---end-----  */

  },
};
</script>

  <style lang="scss" scoped>
.container {
  height: 100vh;
  background-color: #efefef;
}
#___file_upload {
  position: absolute;
  left: -999px;
}

.nav-right {
    padding-right: 0.5rem;
    .nav-lable {
      margin: 0;
      font-size: 0.9rem;
      color: #fff;
    }
  }

.content {
  .tip {
    padding: 0.8rem;
    background-color: #fdfdfd;
    span {
      font-size: 0.9rem;
      color: #666;
      line-height: 1.3rem;
    }
  }
  .img-state {
    height: 0.5rem;
    padding: 0.2rem 0.3rem;
    background-color: #dcdcdc;
    border-radius: 0.5rem;
    span {
      font-size: 0.5rem;
    }
    .state1 {
      color: #666;
    }
    .state2 {
      color: #2ae459;
    }
    .state3 {
      color: #e13366;
    }
  }
  .photo {
    margin-top: 1rem;
    padding: 0.2rem;
    background-color: #fdfdfd;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    .face-img {
      margin: 0.3rem;
      width: 7rem;
      height: 7rem;
      background-size:cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  .upload {
    margin: 0.3rem;
    width: 7rem;
    height: 7rem;
    background-color: #EFEFEF;
    border-radius: 0.5rem;
    img {
      width: 4rem;
      height: 4rem;
    }
  }
  .btn-clock {
    .btn {
      margin: 1rem 0;
      padding: 0.5rem 8rem;
      border-radius: 2rem;
      background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
      span {
        font-size: 0.9rem;
        font-weight: bold;
        color: #FFFFFF;
      }
    }
  }
  
}

.container-dark {
  min-height: 100vh;
  background-color: #2f2e33;
  .content {
    .tip {
      background-color: #2c2b30;
      span {
        color: #888;
      }
    }
    .photo  {
      background-color: #2c2b30;
    }
    .upload {
      background-color: #999;
    }
    .btn-clock {
      background-color: #2c2b30;
    }
  }
}
</style>
